import LxcError from "~/core/models/LxcError.class";
import type { GlobalDeviceConfiguration } from "~/modules/globalDeviceConfiguration/models/GlobalDeviceConfiguration.interface";
import globalDeviceConfigurationService from "~/modules/globalDeviceConfiguration/services/globalDeviceConfiguration.service";

export function useUpdateGlobalDeviceConfiguration({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const error: Ref<LxcError | undefined> = ref();

  async function updateGlobalDeviceConfiguration(
    globalDeviceConfiguration: GlobalDeviceConfiguration,
  ) {
    error.value = undefined;

    const response =
      await globalDeviceConfigurationService.updateOrganizationDeviceModelSpecificConfig(
        {
          organizationCode,
          deviceModelSpecificConfig: {
            external: {
              automaticCertificateRenewalDelay:
                globalDeviceConfiguration.automaticRenewalDelayCurrent,
              pollingFrequency:
                globalDeviceConfiguration.pollingFrequencyCurrent
                  ? globalDeviceConfiguration.pollingFrequencyCurrent * 60
                  : globalDeviceConfiguration.pollingFrequencyCurrent,
            },
            deviceModelUid: globalDeviceConfiguration.uid,
            deviceModelName: globalDeviceConfiguration.friendlyName,
          },
        },
      );

    if (LxcError.check(response)) {
      error.value = response;
    }
  }

  return {
    error,
    updateGlobalDeviceConfiguration,
  };
}
